import { useEffect, useState } from 'react';
import { ShareAltOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { GetMultipleQuotesEnabled, RootState, isSameRooms, getDateOnly } from '@share/utils';
import { IShareCompareState, ISessionKey, IShareCompareHotel, IShareCompareCar, IShareCompareCondo, IGroupedShareCompareCondo } from '@share/common-types';
import { BlueButton } from '@share/components';
import { WhiteButton } from '@components';
import { HasPermission, ViewQuotesSharePermission, isCarsFiltersEmpty } from '@utils';
import { IUser, IAccount, DateSearchTypeEnum } from '@share/common-types';
import { getCondoCompareKey as generateCondoKey } from '@utils';
import './style.scss';
import {
  ILoginState,
  IFiltersState,
  IRoomsState,
  IDatesState,
  ILocationsState,
  IHotelsState,

  ICarsFiltersState,
  ICarsDatesState,
  ICarLocationsState,
  ICarsState,
  ICarsDriverState,

  ICondoGuestsState,
  ICondosState,
  ICondoStrictDatesState,
  ICondoFlexibleDatePickerState

} from '@share/store/slices';
import { isFiltersEmpty } from '@utils';
import { ModalCompare } from './modal-compare';
import { compareActions } from '@share/store/slices';

interface IMapStateToProps {
  hotelsStore: IHotelsState;
  filtersStore: IFiltersState;
  loginStore: ILoginState;
  roomsStore: IRoomsState;
  datesStore: IDatesState;
  sharecompare: IShareCompareState;
  locationsStore: ILocationsState;

  carsFiltersStore: ICarsFiltersState;
  carsDatesStore: ICarsDatesState;
  carsLocationsStore: ICarLocationsState;
  carsStore: ICarsState;
  carsDriverStore: ICarsDriverState;

  condoGuestsStore: ICondoGuestsState;
  condosStore: ICondosState;
  condoStrictDatesStore: ICondoStrictDatesState;
  condoFlexibleDatePickerStore: ICondoFlexibleDatePickerState;
}

interface IMapDispatchToProps {
  setHotelToCompare: (sharecompare: IShareCompareHotel[]) => void;
  setCarToCompare: (sharecompare: IShareCompareCar[]) => void;
  setCondoToCompare: (sharecompare: IShareCompareCondo[]) => void;
}

type Props = IMapStateToProps & IMapDispatchToProps & WrappedComponentProps;

function CompareBarComponent(props: Props) {
  const [showCompareMessage, setShowCompareMessage] = useState(false);
  const [showCompareModal, setshowCompareModal] = useState(false);

  const locationpath = useLocation();
  const path = locationpath?.pathname?.split('/').filter(Boolean).pop();
  const specificPath = locationpath?.pathname?.split('/')[2];

  useEffect(() => {
    if ((path === 'search') || (path === 'deals')) {
      setShowCompareMessage(true);
    } else {
      setShowCompareMessage(false);
    }
  }, [path]);
  const { sharecompare } = props;
  const { loginStore } = props;
  const { user } = loginStore;
  const { account } = loginStore;

  const { hotelcompare } = sharecompare;
  const { filtersStore } = props;
  const { roomsStore } = props;
  const { startDate, endDate } = props.datesStore;
  const { location } = props.locationsStore;
  const { sessionKey } = props.hotelsStore;

  //props for car---
  const { carscompare } = sharecompare;
  const { carsFiltersStore } = props;
  const { carsDatesStore } = props;
  const carstartDate = carsDatesStore.startDate;
  const carendDate = carsDatesStore.endDate;
  const { carsLocationsStore } = props;
  const carpickUp = carsLocationsStore.pickUp;
  const cardropOff = carsLocationsStore.dropOff;
  const { carsStore } = props;
  const carSessionKey = carsStore.sessionKey

  // props for condos-----------
  const { condoscompare } = sharecompare;
  const { condoGuestsStore } = props;
  const { condosStore } = props;
  const { condoFlexibleDatePickerStore } = props;
  const { condoStrictDatesStore } = props;
  const { cachedSelectedLocation } = condosStore;
  const condoSessionKey = condosStore.sessionKey
  const { searchType } = condoStrictDatesStore;
  const condostartDate = condoStrictDatesStore.startDate;
  const condoendDate = condoStrictDatesStore.endDate;
  const { selectedMonths } = condoFlexibleDatePickerStore;


  const isStrictSearch = searchType === DateSearchTypeEnum.Strict;

  // -------------
  const maxCompare = 5;
  const isVacationRentals = false;
  const isFiltersApplied = !isFiltersEmpty(filtersStore, account as IAccount, isVacationRentals);
  const isCarFiltersApplied = !isCarsFiltersEmpty(carsFiltersStore);


  const HasViewQuotesSharePermission = HasPermission(user as IUser, ViewQuotesSharePermission);
  const displayCompareLength = (HasViewQuotesSharePermission || isFiltersApplied) ? 0 : 1;
  const displayCarCompareLength = (HasViewQuotesSharePermission || isCarFiltersApplied) ? 0 : 1;
  const displayCondoCompareLength = HasViewQuotesSharePermission ? 0 : 1;

  const handleHotelCompare = (hotel: IShareCompareHotel) => {
    const { sharecompare } = props;
    const { hotelcompare } = sharecompare;
    const hotelIndex = hotelcompare.findIndex(h => 
      h.hotelId === hotel.hotelId && 
      h.startDate === hotel.startDate && 
      h.endDate === hotel.endDate &&
      isSameRooms(h.rooms, hotel.rooms)
    );
    if (hotelIndex != -1) {
      const updatedHotelCompare = hotelcompare.filter((_, index) => index !== hotelIndex);
      props.setHotelToCompare(updatedHotelCompare);
    }
  }

  const handleHotelGroupRemove = (hotels: IShareCompareHotel[]) => {
    const { sharecompare } = props;
    const { hotelcompare } = sharecompare;
    const updatedHotelCompare = hotelcompare.filter(h => 
      !hotels.some(r => 
        r.hotelId === h.hotelId && 
        r.startDate === h.startDate && 
        r.endDate === h.endDate &&
        isSameRooms(r.rooms, h.rooms) &&
        r.locationObj?.code === h.locationObj?.code
      )
    );
    props.setHotelToCompare(updatedHotelCompare);
  }


  const handleCarCompare = (car: IShareCompareCar) => {
    const { sharecompare } = props;
    const { carscompare } = sharecompare;
    const carIndex = carscompare.findIndex(h => 
      h.id === car.id && 
      h.startDate === car.startDate && 
      h.endDate === car.endDate &&
      h.carRequest?.pickUpTime === car.carRequest?.pickUpTime &&
      h.carRequest?.returnTime === car.carRequest?.returnTime &&
      h.carRequest?.driverAge === car.carRequest?.driverAge &&
      h.carRequest?.countryISO === car.carRequest?.countryISO &&
      ((h as any)?.pickUpLocationObj?.code?.toString() || "unknown_location") === ((car as any)?.pickUpLocationObj?.code?.toString() || "unknown_location") &&
      (((h as any)?.dropOffLocationObj?.code) || "unknown_location") ===(((car as any)?.dropOffLocationObj?.code) || "unknown_location")
    );
    if (carIndex != -1) {
      const updatedCarCompare = carscompare.filter((_, index) => index !== carIndex);
      props.setCarToCompare(updatedCarCompare);
    }
  }

  const handleCarGroupRemove = (cars: IShareCompareCar[]) => {
    const { sharecompare } = props;
    const { carscompare } = sharecompare;
    const updatedCarCompare = carscompare.filter(c => 
      !cars.some(r => 
        r.id === c.id && 
        r.startDate === c.startDate && 
        r.endDate === c.endDate &&
        r.carRequest?.pickUpTime === c.carRequest?.pickUpTime &&
        r.carRequest?.returnTime === c.carRequest?.returnTime &&
        ((r as any)?.pickUpLocationObj?.code?.toString() || "unknown_location") === ((c as any)?.pickUpLocationObj?.code?.toString() || "unknown_location") &&
        (((r as any)?.dropOffLocationObj?.code || (r as any)?.pickUpLocationObj?.code)?.toString() || "unknown_location") ===
        (((c as any)?.dropOffLocationObj?.code || (c as any)?.pickUpLocationObj?.code)?.toString() || "unknown_location")
      )
    );
    props.setCarToCompare(updatedCarCompare);
  }

  const handleCondoCompare = (condo: IShareCompareCondo) => {
    const { sharecompare } = props;
    const { condoscompare } = sharecompare;
    const hasMultipleQuotesEnabled = GetMultipleQuotesEnabled(loginStore);
    const condoIndex = condoscompare.findIndex(h =>
      h.condoId === condo.condoId &&
      h.startDate === condo.startDate &&
      h.endDate === condo.endDate &&
      (!hasMultipleQuotesEnabled || (((h.locationObj?.id)?.toString() || "unknown_location") === ((condo.locationObj?.id)?.toString() || "unknown_location")))
    );
    if (condoIndex != -1) {
      const updatedCondoCompare = condoscompare.filter(h =>
        h.condoId !== condo.condoId ||
        h.startDate !== condo.startDate ||
        h.endDate !== condo.endDate ||
        (hasMultipleQuotesEnabled && (((h.locationObj?.id)?.toString() || "unknown_location") !== ((condo.locationObj?.id)?.toString() || "unknown_location")))
      );
      props.setCondoToCompare(updatedCondoCompare);
    }
  }

  const handleCondoGroupRemove = (condos: IShareCompareCondo[]) => {
    const { sharecompare } = props;
    const { condoscompare } = sharecompare;
    const hasMultipleQuotesEnabled = GetMultipleQuotesEnabled(loginStore);
    const updatedCondoCompare = condoscompare.filter(c => 
      !condos.some(r => 
        r.condoId === c.condoId && 
        generateCondoKey(r) === generateCondoKey(c) &&
        (!hasMultipleQuotesEnabled || (((r.locationObj?.id)?.toString() || "unknown_location") === ((c.locationObj?.id)?.toString() || "unknown_location")))
      )
    );
    props.setCondoToCompare(updatedCondoCompare);
  }

  const handleClearData = () => {
    props.setHotelToCompare([]);
    props.setCarToCompare([]);
    props.setCondoToCompare([]);
  }
  const hasMultipleQuotes = GetMultipleQuotesEnabled(loginStore);

  const isDisabled = (hotelcompare.length > 0 || carscompare.length > 0 || condoscompare.length > 0) && path !== "search" && path !== "condo" && path !== "cars" && path !== "deals";

  const groupByHotelDateRange = <T extends {
    startDate?: string | null;
    endDate?: string | null;
    rooms?: { adultsCount: number; kids?: any[] }[];
    locationObj?: { code?: string | number } | null;
  }>(
    data: T[]
  ) => {
    if (!Array.isArray(data)) return {};

    const result: any = {};

    data.forEach((item) => {
      const start = item.startDate ? getDateOnly(item.startDate) : "unknown";
      const end = item.endDate ? getDateOnly(item.endDate) : "unknown";
      const locationCode =
        item.locationObj?.code?.toString() || "unknown_location";

      let adults = 0;
      let kids = 0;

      item.rooms?.forEach((room) => {
        adults += room.adultsCount || 0;
        kids += room.kids?.length || 0;
      });

      if (!result[locationCode]) {
        result[locationCode] = [];
      }

      const existingGroup = result[locationCode].find(
        (g: any) =>
          g.startDate === start &&
          g.endDate === end &&
          g.guest.adults === adults &&
          g.guest.kids === kids
      );

      if (existingGroup) {
        existingGroup.items.push(item);
      } else {
        result[locationCode].push({
          startDate: start,
          endDate: end,
          guest: { adults, kids },
          items: [item],
        });
      }
    });

    return result;
  };

  const groupByCondoDateRange = (data: IShareCompareCondo[]) => {
    if (!Array.isArray(data)) return {};

    const result: Record<string, IGroupedShareCompareCondo[]> = {};

    data.forEach((item) => {
      const locationId = (item.locationObj?.id)?.toString() || "unknown_location";

      if (!result[locationId]) {
        result[locationId] = [];
      }

      const groupKey = generateCondoKey(item);
      const existingGroup = result[locationId].find(
        (g) => generateCondoKey(g.items[0]) === groupKey
      );

      if (existingGroup) {
        existingGroup.items.push(item);
      } else {
        result[locationId].push({
          startDate: item.startDate || '',
          endDate: item.endDate || '',
          searchType: item.searchType,
          selectedMonths: item.selectedMonths,
          adultsCount: item.adultsCount,
          kidsCount: item.kidsCount,
          bedroomsCount: item.bedroomsCount,
          items: [item],
        });
      }
    });

    return result;
  };

  const groupByCarDateRange = <
    T extends {
      startDate?: string | null;
      endDate?: string | null;
      pickUpLocationObj?: { code?: string | number; name?: string } | null;
      dropOffLocationObj?: { code?: string | number; name?: string } | null;
      carRequest?: {
        pickUpTime?: string;
        returnTime?: string;
        countryISO?: string;
        driverAge?: number;
      };
    }
  >(
    data: T[]
  ) => {
    if (!Array.isArray(data)) return {};

    const result: any = {};

    data.forEach((item) => {
      const start = item.startDate || "unknown";
      const end = item.endDate || "unknown";
      const pickUpTime = item.carRequest?.pickUpTime || "unknown";
      const returnTime = item.carRequest?.returnTime || "unknown";
      const countryISO = item.carRequest?.countryISO || "unknown";
      const driverAge = item.carRequest?.driverAge ?? "unknown";
      const pickUpLocationCode = item.pickUpLocationObj?.code?.toString() || "unknown_location";
      const dropOffLocationCode = (item.dropOffLocationObj?.code || item.pickUpLocationObj?.code)?.toString() || "unknown_location";
      const groupKey = `${pickUpLocationCode}_${dropOffLocationCode}`;

      if (!result[groupKey]) {
        result[groupKey] = [];
      }

      const existingGroup = result[groupKey].find(
        (g: any) =>
          g.startDate === start &&
          g.endDate === end &&
          g.pickUpTime === pickUpTime &&
          g.returnTime === returnTime &&
          g.countryISO === countryISO &&
          g.driverAge === driverAge &&
          g.dropOffLocationCode === dropOffLocationCode
      );

      if (existingGroup) {
        existingGroup.items.push(item);
      } else {
        result[groupKey].push({
          startDate: start,
          endDate: end,
          pickUpTime,
          returnTime,
          countryISO,
          driverAge: driverAge === "unknown" ? null : Number(driverAge),
          pickUpLocationCode,
          dropOffLocationCode,
          items: [item],
        });
      }
    });

    return result;
  };

  const hotelData = groupByHotelDateRange(hotelcompare);
  const carData = groupByCarDateRange(carscompare);
  const condoData = groupByCondoDateRange(condoscompare);
  
  const hotelGroupsCount = Object.values(hotelData).flat().length;
  const carGroupsCount = Object.values(carData).flat().length;
  const condoGroupsCount = Object.values(condoData).flat().length;

  const currentLocationCode = location?.code?.toString() || "unknown_location";
  const selectedHotels = hotelcompare.filter(h => 
    getDateOnly(h.startDate) === getDateOnly(startDate) &&
    getDateOnly(h.endDate) === getDateOnly(endDate) &&
    isSameRooms(h.rooms, roomsStore.rooms) &&
    (h.locationObj?.code?.toString() || "unknown_location") === currentLocationCode
  ).length;
  const currentPickUpTime = carsDatesStore.startDateTimeSelected;
  const currentReturnTime = carsDatesStore.endDateTimeSelected;
  const currentCarPickUpLocationCode = carpickUp?.location?.code?.toString() || "unknown_location";
  const currentCarDropOffLocationCode = (cardropOff?.location?.code || carpickUp?.location?.code)?.toString() || "unknown_location";
  const { driverAge, driverCountry } = props.carsDriverStore;
  const isoDriverAge = Number(driverAge);

  const selectedCars = carscompare.filter(c => 
    c.startDate === carstartDate && 
    c.endDate === carendDate &&
    ((c as any)?.pickUpLocationObj?.code?.toString() || "unknown_location") === currentCarPickUpLocationCode &&
    (((c as any)?.dropOffLocationObj?.code || (c as any)?.pickUpLocationObj?.code)?.toString() || "unknown_location") === currentCarDropOffLocationCode &&
    (!hasMultipleQuotes || (
      c.carRequest?.pickUpTime === currentPickUpTime &&
      c.carRequest?.returnTime === currentReturnTime &&
      c.carRequest?.driverAge === isoDriverAge &&
      c.carRequest?.countryISO === driverCountry
    ))
  ).length;

  const { adultsCount, kidsCount, bedroomsCount } = condoGuestsStore;
  const currentCondoLocationId = (cachedSelectedLocation?.id)?.toString() || "unknown_location";
  const selectedCondos = condoscompare.filter(c =>
    generateCondoKey(c) === generateCondoKey({ startDate: condostartDate, endDate: condoendDate, searchType, selectedMonths, adultsCount, kidsCount, bedroomsCount }) &&
    (!hasMultipleQuotes || (((c.locationObj?.id)?.toString() || "unknown_location") === currentCondoLocationId))
  ).length;

  const otherHotelsCount = selectedHotels > 0 ? hotelGroupsCount - 1 : hotelGroupsCount;
  const otherCarsCount = selectedCars > 0 ? carGroupsCount - 1 : carGroupsCount;
  const otherCondosCount = selectedCondos > 0 ? condoGroupsCount - 1 : condoGroupsCount;
  const hasAnyQuoteGroups = hotelGroupsCount > 0 || carGroupsCount > 0 || condoGroupsCount > 0;


  const renderCompareMessage = (type: string, selectedCount: number, otherCount: number = 0) => {
    const parts: string[] = [];
    const totalGroupCount = hotelGroupsCount + carGroupsCount + condoGroupsCount;
    const effectiveSelectedCount = isDisabled ? totalGroupCount : selectedCount;
    const showSelectedCounter = specificPath === "cars" || specificPath === "condo" || specificPath === "search";

    const hotelCountForMessage = type === 'hotel' ? (isDisabled ? hotelGroupsCount : otherCount) : hotelGroupsCount;
    const carCountForMessage = type === 'cars' ? (isDisabled ? carGroupsCount : otherCount) : carGroupsCount;
    const condoCountForMessage = type === 'condo' ? (isDisabled ? condoGroupsCount : otherCount) : condoGroupsCount;

    if (hotelCountForMessage > 0) {
      parts.push(`${hotelCountForMessage} hotel ${hotelCountForMessage === 1 ? 'quote' : 'quotes'}`);
    }
    if (carCountForMessage > 0) {
      parts.push(`${carCountForMessage} car ${carCountForMessage === 1 ? 'quote' : 'quotes'}`);
    }
    if (condoCountForMessage > 0) {
      parts.push(`${condoCountForMessage} condo ${condoCountForMessage === 1 ? 'quote' : 'quotes'}`);
    }

    const totalSelectedCount = hotelCountForMessage + carCountForMessage + condoCountForMessage;
    const selectedSummary = parts.length ? `${parts.join(', ')} ${totalSelectedCount === 1 ? 'is' : 'are'} already selected` : '';

    return (
    <div className="result-wrapper__compare-message">
      {showSelectedCounter && (
        <>
          {effectiveSelectedCount > 1 && (
            <FormattedMessage id={`results.${type}.card.compare.message`} values={{ selected: effectiveSelectedCount, total: maxCompare }} />
          )}

          {effectiveSelectedCount === 1 && (
            <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>
              <FormattedMessage id="results.hotel.card.compare.message.select_more" />
            </span>
          )}
        </>
      )}
     
      {!!selectedSummary && (
        <div className="other-quotes-message" >
          {selectedSummary}
        </div>
      )}

      <div className="compare-buttons">
        {(hotelcompare.length || carscompare.length || condoscompare.length) && (
          <WhiteButton className="compare-clear-button" onClick={handleClearData}>
            <FormattedMessage id="results.hotel.card.compare.clear_selection" />
          </WhiteButton>
        )}

        <BlueButton
          className="compare-button"
          disabled={
            hotelcompare.length <= displayCompareLength &&
            carscompare.length <= displayCarCompareLength &&
            condoscompare.length <= displayCondoCompareLength
          }
          onClick={() => setshowCompareModal(true)}
        >
          {HasViewQuotesSharePermission ? (
            <FormattedMessage id="results.hotel.card.compare.share" />
          ) : (
            <FormattedMessage id="results.hotel.card.compare" />
          )}
        </BlueButton>
      </div>
    </div>
  );
  };



  return (
    <>
      {showCompareMessage && hasMultipleQuotes && hasAnyQuoteGroups && isDisabled && (
        hotelGroupsCount > 0
          ? renderCompareMessage("hotel", selectedHotels, otherHotelsCount)
          : carGroupsCount > 0
            ? renderCompareMessage("cars", selectedCars, otherCarsCount)
            : renderCompareMessage("condo", selectedCondos, otherCondosCount)
      )}

      {showCompareMessage && hasMultipleQuotes && hasAnyQuoteGroups && !isDisabled && specificPath !== "cars" && specificPath !== "condo" &&
        renderCompareMessage("hotel", selectedHotels, otherHotelsCount)}

      {showCompareMessage && hasMultipleQuotes && hasAnyQuoteGroups && !isDisabled && specificPath !== "search" && specificPath !== "condo" &&
        renderCompareMessage("cars", selectedCars, otherCarsCount)}

      {showCompareMessage && hasMultipleQuotes && hasAnyQuoteGroups && !isDisabled && specificPath !== "search" && specificPath !== "cars" &&
        renderCompareMessage("condo", selectedCondos, otherCondosCount)}


      {isDisabled && (
        <div
          className="currency-calculator"
          style={{ left: "inherit", right: "20px", bottom: "75px" }}
          onClick={() => setShowCompareMessage((prev) => !prev)}
        >
          <div className={`currency-calculator__dropdown-icon shareBtn ${showCompareMessage ? 'active' : ''}`}>
            <ShareAltOutlined />
          </div>
        </div>
      )}
      <ModalCompare
        visible={showCompareModal}
        hotels={hotelData}
        isVacationRentals={isVacationRentals}
        locationCode={location?.code?.toString() || ''}
        sessionKey={sessionKey as ISessionKey}
        onHotelRemove={handleHotelCompare}

        cars={carData}
        carLocationCode={carpickUp?.location?.code?.toString()}
        carSessionKey={carSessionKey}
        onCarRemove={handleCarCompare}

        condos={condoData}
        adultsCount={condoGuestsStore.adultsCount}
        kidsCount={condoGuestsStore.kidsCount}
        bedroomsCount={condoGuestsStore.bedroomsCount}
        locationObject={cachedSelectedLocation}
        condosessionKey={condoSessionKey}
        isFlexible={!isStrictSearch}
        months={selectedMonths}
        onCondoRemove={handleCondoCompare}

        onHotelGroupRemove={handleHotelGroupRemove}
        onCarGroupRemove={handleCarGroupRemove}
        onCondoGroupRemove={handleCondoGroupRemove}

        onCancel={() => setshowCompareModal(false)}

      />
    </>
  );
}


const mapStateToProps = (state: RootState): IMapStateToProps => ({
  filtersStore: state.filtersStore,
  loginStore: state.loginStore,
  roomsStore: state.roomsStore,
  datesStore: state.datesStore,
  sharecompare: state.compareStore,
  locationsStore: state.locationsStore,
  hotelsStore: state.hotelsStore,

  carsFiltersStore: state.carsFiltersStore,
  carsDatesStore: state.carsDatesStore,
  carsLocationsStore: state.carsLocationsStore,
  carsStore: state.carsStore,
  carsDriverStore: state.carsDriverStore,

  condoGuestsStore: state.condoGuestsStore,
  condosStore: state.condosStore,
  condoStrictDatesStore: state.condoStrictDatesStore,
  condoFlexibleDatePickerStore: state.condoFlexibleDatePickerStore,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, undefined, Action>): IMapDispatchToProps => ({
  setHotelToCompare: (hotelcompare: IShareCompareHotel[]) => {
    dispatch(compareActions.setHotelToCompare(hotelcompare));
  },

  setCarToCompare: (carcompare: IShareCompareCar[]) => {
    dispatch(compareActions.setCarToCompare(carcompare));
  },

  setCondoToCompare: (carcompare: IShareCompareCondo[]) => {
    dispatch(compareActions.setCondoToCompare(carcompare));
  },

});


const IntlWrapped = injectIntl(CompareBarComponent);
export const CompareBar = connect(mapStateToProps, mapDispatchToProps)(IntlWrapped);
